
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    image_url: { type: String, required: false }
  },
  computed: {
    url(): string {
      // force browser to use image from the server instead of cache
      const t = new Date().getTime()
      return this.image_url ? `${this.image_url}?t=${t}` : ''
    }
  }
})
